<template>
  <div>
    <TrackerDetails :trackedBill="mappedTracker"></TrackerDetails>
    <!-- <BillDetails
      :bill="selectedBill"
      :billStub="billStub"
      :loading="false"
      :trackedBill="trackedBill"
      :isExtended="false"
      @refreshTrackedBills="refreshTrackedBills"
    >
      <template v-slot:tracker>
      </template>
    </BillDetails> -->
  </div>
</template>
<script>
import { get, sync, commit, call } from 'vuex-pathify'
import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'
dayjs.extend(relativeTime)
import BillDetails from '@components/lso/BillDetails'
import TrackerDetails from '@components/lso/TrackerDetails'
import download from 'downloadjs'
export default {
  //model: {
  //	prop: ''
  //},
  props: {
    trackedBill: { type: Object, required: true },
  },
  components: {
    BillDetails,
    TrackerDetails,
  },
  filters: {},
  data() {
    return {
      dayjs,
      selectedBill: {},
      loadingCount: 0,
    }
  },
  mounted() {},
  computed: {
    ...get('bills', ['billDetails']),

    billStub() {
      return {
        bill: this.trackedBill.BillNumber,
        catchTitle: this.trackedBill.ShortTitle,
        specialSessionValue: this.trackedBill.SpecialSession,
        sponsor: this.trackedBill.Sponsor,
        billType: this.trackedBill.BillType,
        billStatus: this.trackedBill.LsoBillStatus,
        effectiveDate: null,
        signedDate: null,
        lastAction: this.trackedBill.LsoLastAction,
        lastActionDate: this.trackedBill.LsoLastActionDate,
        enrolledNumber: null,
        chapter: null,
        year: this.trackedBill.Year,
      }
    },
    payload() {
      if (this.trackedBill) {
        return {
          year: this.trackedBill.Year,
          billNum: this.trackedBill.BillNumber,
          specialSessionValue: this.trackedBill.SpecialSession,
        }
      } else {
        return null
      }
    },
    mappedTracker() {
      return {
        ...this.trackedBill,
        recent: this.recentActivity,
      }
    },
    recentActivity() {
      var combined = this.trackedBill.Comments.concat(
        this.trackedBill.Links.map((item) => {
          return {
            ...item,
            link: item.URL.startsWith('http') ? item.URL : 'http://' + item.URL,
          }
        })
      )
        .concat(this.trackedBill.Documents)
        .sort((a, b) => new Date(b.CreatedDate) - new Date(a.CreatedDate))
      if (combined.length > 0) {
        return combined[0]
      } else {
        return null
      }
    },
  },
  methods: {
    ...call('bills', ['loadBill', 'getSelectedBill']),
    ...call('trackedBill', ['setBillDetails', 'loadTrackedBillCardDetails']),
    refreshTrackedBills() {
      this.$emit('refreshTrackedBills')
    },
  },
  watch: {},
}
</script>

<style scoped></style>
